// import { EDITOR_JS_TOOLS } from "./tools/tools";
import { createReactEditorJS } from "react-editor-js";
import React, { useRef, useCallback, useMemo, memo, useEffect } from "react";

import Pdf from "./tools/FileUpload";
import List from "@editorjs/list";
import Embed from "@editorjs/embed";
import CodeEditor from "./tools/CodingEditor";
import RichTextEditor from "./tools/RichTextEditor";
import Table from "@editorjs/table";
import Image from "./tools/Image";
// import MathEditor from 'editorjs-mathlive';
import NestedList from "@editorjs/nested-list";
import { useContext } from "react";
import Video from "./tools/Video";
import Alert from "editorjs-alert";
import Header from "@editorjs/header";
// import SandPack from './SandpackTool';
import AlertContext from "../../context/AlertContext";
import useS3FileManagement from "../../Hooks/useS3FileManagement";
import MathEditor from "./tools/MathEditor";

// const CodeTool = require('@editorjs/code');
const Warning = require("@editorjs/warning");
const Delimiter = require("@editorjs/delimiter");
const FontSize = require("editorjs-inline-font-size-tool");
// const FontFamily = require('editorjs-inline-font-family-tool');
const CodeTool = require("@editorjs/code");
const ColorPlugin = require("editorjs-text-color-plugin");

function openModal(linkUrl) {
  // Create a modal element
  const modal = document.createElement("div");
  modal.classList.add("modal");

  // Create an iframe to display the linked content
  const iframe = document.createElement("iframe");
  iframe.src = linkUrl;

  // Add the iframe to the modal
  modal.appendChild(iframe);

  // Add the modal to the document body
  document.body.appendChild(modal);

  // Add a close button to the modal
  const closeButton = document.createElement("button");
  closeButton.textContent = "Close";
  closeButton.addEventListener("click", () => {
    // Remove the modal when the close button is clicked
    document.body.removeChild(modal);
  });
  modal.appendChild(closeButton);
}

const ContentEditor = ({
  userInput = {},
  setUserInput = null,
  readOnly = false,
  result = null,
  qnid,
}) => {
  const { getPreSignedUrl } = useS3FileManagement();
  const { isAdmin, preview, testData } = useContext(AlertContext);
  const memoizedContext = useMemo(
    () => ({ isAdmin, preview: readOnly }),
    [isAdmin, readOnly],
  );

  const ReactEditorJS = createReactEditorJS();
  const editorRef = useRef(null);
  const editorCore = useRef(null);
  let resultRef = useRef(result);

  const EDITOR_JS_TOOLS = useMemo(
    () => ({
      header: {
        class: Header,
        inlineToolbar: true,
        config: { placeholder: "Header" },
        shortcut: "CMD+SHIFT+H",
      },
      codeeditor: { class: CodeEditor },
      code: { class: CodeTool, inlineToolbar: true },
      embed: {
        class: Embed,
        config: { services: { youtube: true, vimeo: true } },
      },
      color: {
        class: ColorPlugin,
        config: {
          colorCollections: [
            "#EC7878", "#9C27B0", "#673AB7", "#3F51B5", "#0070FF",
            "#03A9F4", "#00BCD4", "#4CAF50", "#8BC34A", "#CDDC39", "#FFF",
          ],
          defaultColor: "#FF1300",
          type: "text",
          customPicker: true,
        },
      },
      fontsize: FontSize,
      marker: {
        class: ColorPlugin,
        config: { defaultColor: "#FFBF00", type: "marker" },
      },
      image: {
        class: Image,
        config: {
          qnid,
          getPreSignedUrl,
          getResult: () => resultRef.current,
        },
      },
      video: {
        class: Video,
        config: { qnid: qnid },
      },
      pdf: {
        class: Pdf,
        config: { qnid },
      },
      richtexteditor: {
        class: RichTextEditor,
        config: { context: memoizedContext },
      },
      mathlive: {
        class: MathEditor,
        // inlineToolbar: true,
        config: {
          onMathChange: () => {
            handleOnChange();
          },
          virtualKeyboardMode: 'manual',
          defaultMode: 'math',
          smartMode: true,
          virtualKeyboardTheme: 'material',
          keypressSound: null,
          plonkSound: null,
        },
      },
      list: {
        class: NestedList,
        inlineToolbar: true,
      },
      uolist: {
        class: List,
        inlineToolbar: true,
        config: {
          defaultStyle: "unordered",
        },
        shortcut: "CMD+SHIFT+L",
      },
      //  Removed uolist to avoid paste handler conflict
      table: Table,
      delimeter: Delimiter,
      warning: Warning,
      alert: {
        class: Alert,
        inlineToolbar: true,
        shortcut: "CMD+SHIFT+A",
        config: {
          defaultType: "primary",
          messagePlaceholder: "Enter something",
        },
      },
    }),
    [qnid, getPreSignedUrl, memoizedContext]
  );

  const Video_Editor_Js_Tools = useMemo(
    () => ({
      header: {
        class: Header,
        inlineToolbar: true,
        config: { placeholder: "Header" },
        shortcut: "CMD+SHIFT+H",
      },
      video: {
        class: Video,
        config: { qnid },
      },
      list: {
        class: NestedList,
        inlineToolbar: true,
      },
      uolist: {
        class: List,
        inlineToolbar: true,
        config: {
          defaultStyle: "unordered",
        },
        shortcut: "CMD+SHIFT+L",
      },
    }),
    [qnid]
  );

  const handleInitialize = useCallback((instance) => {
    instance._editorJS.isReady
      .then(() => {
        editorCore.current = instance;
      })
      .catch((err) => console.log("An error occured", err));
  }, []);

  const getVideoDuration = (file) => {
    return new Promise((resolve) => {
      if (
        file.data.file &&
        file.data.file.type &&
        file.data.file.type.includes("video")
      ) {
        const video = document.createElement("video");
        video.preload = "metadata";
        video.onloadedmetadata = function () {
          window.URL.revokeObjectURL(video.src);
          resolve(video.duration);
        };
        video.src = URL.createObjectURL(file.data.file);
      } else {
        userInput.description.blocks.forEach((block) => {
          if (file.id === block.id) {
            if (block.data.url === file.data.url) {
              resolve(block.data.duration);
            }
          }
        });
        // for(let i=0;i<Props.UserInput.description.blocks.length;i++){
        //   if(file.id == Props.UserInput.description.blocks[i].id){
        //     console.log("coming isndie the ifff");
        //     if(Props.UserInput.description.blocks[i].data.url==file.data.url){
        //       console.log("coming isndie the ifff ifffff");
        //       resolve(Props.UserInput.description.blocks[i].data.duration);
        //     }
        //   } else {
        //     console.log("coming isndie the elseee");
        //   }
        // }
      }
    });
  };

  const handleOnChange = useCallback(
    async (value) => {
      try {
        const savedData = await editorCore.current.save();
        let totalduration = 0;
        for (let i = 0; i < savedData.blocks.length; i++) {
          if (savedData.blocks[i].type === "video") {
            const duration = await getVideoDuration(savedData.blocks[i]);
            savedData.blocks[i].data.duration = duration;
            totalduration += duration;
          }
          const mathBlocks = savedData.blocks.filter(b => b.type === "math");
          console.log("Math blocks saved:", JSON.stringify(mathBlocks, null, 2));
        }
        savedData.time = totalduration;
        console.log("savedData", savedData);
        setUserInput((prev) => ({ ...prev, description: savedData }));
        // Props.setuserinp({ ...Props.UserInput, description: newData });
        // Props.setNewContent(savedData);
        // Props.setData(savedData);

        const editorContainer =
          document.getElementsByClassName("editor-container");
        editorContainer.scrollTop = editorContainer.scrollHeight;
      } catch (error) { }
    },
    [setUserInput],
  );

  console.log("......userInput", userInput);

  return (
    <div className="editor-wrapper">
      {Object.keys(userInput).length !== 0 && (
        <>
          <ReactEditorJS
            autofocus={true}
            readOnly={readOnly}
            tools={
              parseInt(userInput.contentType) === 0 ||
                userInput.videocontent === 0
                ? EDITOR_JS_TOOLS
                : Video_Editor_Js_Tools
            }
            onChange={handleOnChange}
            className={"reactEditorjs"}
            onInitialize={handleInitialize}
            placeholder={"Let's Write an Awesome Tutorial!"}
            instanceRef={(instance) => (editorRef.current = instance)}
            defaultValue={
              userInput.description
                ? typeof userInput.description === "string"
                  ? JSON.parse(userInput.description)
                  : userInput.description
                : {}
            }
          />
        </>
      )}
    </div>
  );
};

export default ContentEditor;